<template>
  <table
    data-testId="table"
    border="0"
    width="100%">
    <tr :style="{ backgroundColor: backgroundColor }">
      <td class="cell">{{ index + 1 }}</td>
      <td class="cell">{{ Maglink.LevelFormat(data.endLevel, levelUnit) }}</td>
      <td class="cell">{{ Maglink.VolumeFormat(data.sale, volumeUnit) }}</td>
      <td class="cell">{{ Maglink.PercentageFormat(data.referenceVariance) }}</td>
      <td class="cell">{{ Maglink.PercentageFormat(data.variance) }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'TankStraptableDetailItemAcrEvalSegments',
  props: {
    height: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    levelUnit: {
      type: Number,
      default: 0
    },
    volumeUnit: {
      type: Number,
      default: 0
    },
    backgroundColor: {
      type: String,
      default: '#FFF'
    }
  }
}
</script>

<style scoped>
.cell {
  width: 16%;
  display: inline-block;
  text-align: right;
}
</style>
